import PreventNaN from "./PreventNaN";
import Text, { TextColors, TextSizes, TextWeights } from "./Text";

interface IPercentageTextProps {
    children: number;
    color?: TextColors;
    size?: TextSizes;
    fontWeight?: TextWeights;
}

export default function PercentageText({ children, color = "900", fontWeight = "medium", size = "base" }: IPercentageTextProps) {
    const percentage = (Math.round(children * 1000) / 1000);
    return (
        <Text color={color} size={size} fontWeight={fontWeight}><PreventNaN>{percentage}</PreventNaN>%</Text>
    )
}